import { NetworkIdSchema } from "../network/network.js";
import z from "zod";
var MempoolTxnStatus = /* @__PURE__ */ ((MempoolTxnStatus2) => {
  MempoolTxnStatus2["TRANSACTION_STATUS_UNSPECIFIED"] = "unspecified";
  MempoolTxnStatus2["MINED"] = "mined";
  MempoolTxnStatus2["PENDING"] = "pending";
  MempoolTxnStatus2["DROPPED"] = "dropped";
  MempoolTxnStatus2["REORGED"] = "reorged";
  MempoolTxnStatus2["FINALIZED"] = "finalized";
  MempoolTxnStatus2["EXECUTED"] = "executed";
  MempoolTxnStatus2["SEALED"] = "sealed";
  MempoolTxnStatus2["EXPIRED"] = "expired";
  MempoolTxnStatus2["DROPPED_AND_REPLACED"] = "dropped_and_replaced";
  return MempoolTxnStatus2;
})(MempoolTxnStatus || {});
const MempoolTxnSchema = z.object({
  appId: z.string().optional(),
  appName: z.string().optional(),
  networkId: NetworkIdSchema.optional(),
  txnData: z.string(),
  txnHash: z.string(),
  fromAddress: z.string().optional(),
  toAddress: z.string().optional(),
  nonce: z.number().optional(),
  gas: z.string().optional(),
  blockNumber: z.number().optional(),
  txnStatus: z.nativeEnum(MempoolTxnStatus).optional(),
  requestedAt: z.string().datetime().optional(),
  statusChangedAt: z.string().datetime().optional(),
  maxFeePerGas: z.string().optional(),
  maxPriorityFeePerGas: z.string().optional(),
  type: z.string().optional(),
  value: z.string().optional()
});
export {
  MempoolTxnSchema,
  MempoolTxnStatus
};
//# sourceMappingURL=mempool.js.map